import { Button, CircularProgress } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function RejectedRequests({
  getAssignmentCourses,
  RejectedCoursesData,
  AssCourses,
  setAssCourses,
}) {
  let api = useAxiosPrivate();

  let [loading, setLoading] = useState(false);
  let [coursetoRemoveFromReject, setcoursetoRemoveFromReject] = useState({});

  function removerejectalignwithdatabase(code) {
    let arr = [];
    AssCourses.forEach((course) => {
      if (course.course_code === code) {
        course.declined = false;
      }
      arr.push(course);
    });

    setAssCourses(arr);
  }

  const columns = [
    {
      name: "Course Name",
      options: {
        filter: false,
      },
    },
    {
      name: "Code",
      options: {
        filter: false,
      },
    },
    {
      name: "Cr.Hr",
      options: {
        filter: false,
      },
    },
    {
      name: "LEH",
      options: {
        filter: false,
      },
    },
    {
      name: "Requested By",
      options: {
        filter: true,
      },
    },
    {
      name: "Action",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              onClick={() => {
                setcoursetoRemoveFromReject({
                  ...coursetoRemoveFromReject,
                  courseCode: value.courseCode,
                  requester: value.requester,
                  requestedTo: value.requestedTo,
                  batch: value.batch,
                });
                RemoveFromReject();
              }}
              sx={{
                border: "1px solid gray",
                color: "red",
              }}
              variant="outlined"
            >
              {value.reject}
            </Button>
          );
        },
      },
    }, //for filter of batch on front end
    {
      name: "Batch",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Admission Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Program Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
  ];

  async function RemoveFromReject() {
    let resp =
      await api.get(`courseallocation/removeRejectedRequests?batch=${coursetoRemoveFromReject.batch}
        &courseCode=${coursetoRemoveFromReject.courseCode}
        &requester=${coursetoRemoveFromReject.requester}
        &requestedTo=${coursetoRemoveFromReject.requestedTo}`);

    if (resp.data.msg === true) {
      removerejectalignwithdatabase(coursetoRemoveFromReject.courseCode);
    }
  }

  const options = {
    print: "false",
    download: "false",
    selectableRows: "none",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    expandableRows: false,
  };

  return (
    <div
      className="AssCourseTableWrapper"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "90%" }}>
        {loading === false ? (
          <MUIDataTable
            title={"Course List"}
            data={RejectedCoursesData}
            columns={columns}
            options={options}
          />
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
}

export default RejectedRequests;
